<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <!-- Business Banner -->
    <BannerComponent
      imageSrc="capabilities/program management/program-management-banner.jpg"
      :bannerHeadingColor="'#fff'"
      :isOverlay="true"
      heading="Program Management and Strategy"
      subheading="Strategic Excellence, and Flawless Execution Through Exemplary Services"
    />

    <div class="modernization-description" data-aos="fade-up">
      <v-row>
        <v-col
          :xs="12"
        >
          <p> {{ appModernizationDesc }} </p>
        </v-col>
      </v-row>
    </div>
    
    id: 0,
      :subHeading="`BENEFITS`"
      :cardItems="benefitsItems"
    />
    <CardComponent 
      :subHeading="`CORE CAPABILITIES`"
      :cardItems="coreCapabilitiesItems"
    />
    <SectionComponent
      relatedTitle="RELATED CAPABILITIES"
      :paragraphContent="paragraphContent"
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    CardComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      appModernizationDesc: 'G14C offers Program Management and Strategy services performing activities and processes designed to oversee and coordinate a group of related projects to achieve specific strategic goals. Our Program Management and Strategy services ensure that multiple projects align with the organization\'s strategic objectives and are executed efficiently and effectively to deliver the intended benefits. Our experts manage project interdependencies, provide capacity planning, develop and manage project schedules and deliverables, perform risk management and governance, and help manage overlapping requirements and competing priorities for our customers’ portfolio of projects.',
      benefitsItems: [
        {
          id: 1,
          subFolder:'capabilities', 
          folder:'program management',
          imageUrl: 'Project Coordination.jpg',
          text: 'Cross Project Coordination',
          hoverIcon: 'vector.png',
          hoverText: 'Provides coordination for programs and projects that have interdependent or overlapping goals. Our program management services ensures that these projects work together seamlessly, minimizing conflicts and ensuring they collectively achieve their objectives.'
        },{
          id: 2,
          subFolder:'capabilities', 
          folder:'program management',
          imageUrl: 'Decision Support.jpg',
          text: 'Decision Support',
          hoverIcon: 'chart.png',
          hoverText: 'Our program managers provide decision-makers with the information needed to make informed choices about the allocation of resources, adjustments to project scope, and other critical decisions.'
        },{
          id: 3,
          subFolder:'capabilities',  
          folder:'program management',
          imageUrl: 'Improved Efficiency.jpg',
          text: 'Improved Efficiency',
          hoverIcon: 'trend-down.png',
          hoverText: 'Coordinates and optimizes the use of resources across multiple projects based on optimal capacity to reduce redundancy, minimize resource conflicts, and increase overall efficiency.'
        },{
          id: 4,
          subFolder:'capabilities',  
          folder:'program management',
          imageUrl: 'Increased Accountability.jpg',
          text: 'Increased Accountability',
          hoverIcon: 'lock.png',
          hoverText: 'Our program managers measure performance by the overall success of the program, which enhances accountability and ensures that the program\'s objectives are achieved.'
        }
      ],
      coreCapabilitiesItems: [
        {
          id: 5,
          subFolder:'capabilities',  
          folder:'program management',
          imageUrl: 'Benefits Realization.jpg',
          text: 'Benefits Realization',
          hoverIcon: 'analysis.png',
          hoverText: 'Focuses on achieving the intended benefits and outcomes of the mission, program, or project including improved efficiency, cost savings, increased revenue, or other strategic advantages.'
        },{
          id: 6,
          subFolder:'capabilities',  
          folder:'program management',
          imageUrl: 'Governance.jpg',
          text: 'Governance',
          hoverIcon: 'inventory.png',
          hoverText: 'Establishes a governance structure to provide oversight and decision-making authority for the program involving program managers, stakeholders, and project managers.'
        },{
          id: 7,
          subFolder:'capabilities',  
          folder:'program management',
          imageUrl: 'Performance Monitoring.jpg',
          text: 'Performance Monitoring and Risk Management',
          hoverIcon: 'ai-brain.png',
          hoverText: 'Continuously monitors the progress of each project within the program to ensure they are on track, and taking corrective actions and/or course corrections as necessary. Identifies and mitigates risks that affect the successful execution of the program, including risks associated with individual projects and their interactions.'
        },{
          id: 8,
          subFolder:'capabilities',  
          folder:'program management',
          imageUrl: 'Planning-Coordination.jpg',
          text: 'Planning, Coordination and Reporting',
          hoverIcon: 'cloud-done.png',
          hoverText: 'Provides a program management plan that outlines the scope, objectives, schedule, and resource allocation for all related projects. Coordinates the efforts of various project teams to ensure they work together effectively. Provides regular updates and status reports to stakeholders and senior management to keep them informed about the program\'s progress.'
        },{
          id: 9,
          subFolder:'capabilities', 
          folder:'program management',
          imageUrl: 'Resource Management.jpg',
          text: 'Resource Management',
          hoverIcon: 'software-license.png',
          hoverText: 'Provides capacity planning, allocates and managing resources, including personnel, budget, and equipment, to ensure that projects are adequately resourced.'
        },{
          id: 10,
          subFolder:'capabilities', 
          folder:'program management',
          imageUrl: 'Strategic Alignment.jpg',
          text: 'Strategic Alignment',
          hoverIcon: 'microservices.png',
          hoverText: 'Ensures and monitors all projects within a program are aligned with the organization\'s strategic goals and objectives, capital investments, and budgets.'
        }
      ],
      paragraphContent: `With decades of experience, G14C provide program management capabilities and strategy services for the Federal, State and Local government sectors, as well as commercial and non-profit customers. Our program managers have extensive knowledge and experience in project and program management bringing a wealth of best practices, tools, and techniques to help customers avoid common pitfalls and ensuring programs and projects runs smoothly. Our program managers have expertise allocating resources, including people, time, and budget, more efficiently, and assist in prioritizing tasks and activities to ensure that the most critical elements of your program are given the correct level of attention. Our program management and strategy activities identify, assess, and mitigate risks, provide accurate communications to stakeholders, and ensures alignments strategic objectives. We provide guidance on how to set and track KPIs (Key Performance Indicators) to measure the program's success in relation to your broader goals, perform program and project governance, and establish quality assurance surveillance methods to assure the program and project benefits are realized.`,
      sectionContents: [
        '“I want to take a minute to thank you all for helping to make the ITSM program implementation effort and presentation "shine" in front of the Advisory Council. To hear the Public Safety Chair, announce candidly that this is one of the best run projects is incredible.”',
        '“It has been a pleasure working with you and thank you for helping our team stay on the track by creating excellent project plans and related documentation. Thank you for helping coordinate all the communications with users and managing all the customer expectations during the project lifecycle. Right from the first meeting for project kick off to go-live you had full control of the project and kept all the resources and project tasks on track and completed within the duration allotted as well as meeting all the deliverables”',
      ],
      additionalContent: [
        'Montgomery County Government, CIO', 
        'WSSC, Program Manager', 
      ],
      cardData: [
        {
          className: 'cloud',
          color: '#7594FE',
          heading: 'Cloud',
          link: 'cloud'
        },
        {
          className: 'devsecops',
          color: '#50E1FE',
          heading: 'Application Modernization	',
          link: 'application-modernization'
        },
        {
          className: 'security',
          color: '#E2BF66',
          heading: 'Cyber Security',
          link: 'cyber-security'
        },
        {
          className: 'devsecops',
          color: '#50E1FE',
          heading: 'DevSecOps',
          link: 'devsecops'
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>